import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {Location, NgOptimizedImage} from '@angular/common';
import {PrintService} from '@core/services/print.service';
import {RouterModule} from '@angular/router';
import {ProductImagesComponent} from '../product-image/product-images.component';
import {ProductRightComponent} from '../product-right/product-right.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {StoryblokService} from '@core/services/storyblok.service';
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import {ProductTopCtaComponent} from '@layout/components/product/product-top-cta/product-top-cta.component';
import {ProductQuickInfoComponent} from '@layout/components/product/product-quick-info/product-quick-info.component';
import {
  ProductDiscountLabelComponent
} from '@layout/components/product/product-discount-label/product-discount-label.component';
import {
  ProductCustomBadgeComponent
} from '@layout/components/product/product-custom-badge/product-custom-badge.component';
import {ProductTagsComponent} from '@layout/components/product/product-tags/product-tags.component';
import {
  ProductDescriptionSectionComponent
} from '@modules/page/components/product/components/product-description-section/product-description-section.component';
import {ProductPriceService} from '@core/services/product-price.service';

@Component({
  selector: 'app-product-left',
  templateUrl: './product-left.component.html',
  styleUrls: ['./product-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, RouterModule, ProductImagesComponent, ProductDiscountLabelComponent, ProductCustomBadgeComponent, ProductRightComponent, ProductDescriptionSectionComponent, FontAwesomeModule, ProductTopCtaComponent, ProductQuickInfoComponent, ProductTagsComponent]
})
export class ProductLeftComponent {
  printService = inject(PrintService);
  storyblokService = inject(StoryblokService);
  private _location = inject(Location);
  private productPriceService = inject(ProductPriceService);


  readonly product = input<WineProduct>();

  backClicked() {
    this._location.back();
  }

  printPDF() {
    this.printService.printDocument();
  }

  // Check if product has custom badge HTML with a valid discount
  hasCustomBadge = computed(() => {
    const product = this.product();
    if (!product?.customBadgeHTML) {
      return false;
    }
    
    // Use the ProductPriceService to calculate discount percentage
    const discountPercentage = this.productPriceService.calculateDiscountPercentage(product);
    return discountPercentage > 0;
  });

  protected readonly faAngleLeft = faAngleLeft;
}
